export var OptionOrder;

(function (OptionOrder) {
  OptionOrder["Ascending"] = "asc";
  OptionOrder["Descending"] = "desc";
})(OptionOrder || (OptionOrder = {}));